export const translations = {
  zh: {
    // Navbar
    nav: {
      home: '首页',
      features: '平台能力',
      download: '节点下载',
      docs: '文档',
      openCenter: '开放中心',
      downloadBtn: '立即使用'
    },
    
    // Home Page
    home: {
      // Hero Section
        hero: {
          status: 'Avelia Runtime 已在线',
          feature1: '云端理解 · 统一调度',
          feature2: '本地执行 · 可验证推进',
          feature3: '知识沉淀 · 长期复用',
          title: '让每一次意图，直达真实世界',
          subtitle: '智能在项目、设备与环境之间自然流动',
          description: '为持续创造、长期协作与跨端执行而设计的智能平台',
          downloadBtn: '免费体验',
          featuresBtn: '查看平台结构'
        },
      
      // Capabilities Section
      capabilities: {
        title: 'Avelia 的工作主链',
        subtitle: '不是把能力堆成孤立工具，而是把理解、执行和沉淀串成一条持续推进链路。',
        conversation: {
          title: '会话层',
          subtitle: '目标表达入口',
          desc: '用户通过自然语言发起目标、补充上下文，并持续查看进展与结果。'
        },
        task: {
          title: '任务层',
          subtitle: '可推进的运行对象',
          desc: '把请求转成有状态的执行过程，明确下一步动作、完成条件与阻塞原因。'
        },
        knowledge: {
          title: '知识层',
          subtitle: '长期资产沉淀',
          desc: '会话、项目、文档与结果持续沉淀，为后续理解、检索与复用提供基础。'
        },
        node: {
          title: '节点层',
          subtitle: '真实环境执行面',
          desc: '连接桌面、服务器和移动端节点，让 AI 进入环境、执行动作并回传结果。'
        }
      },
      
      // Features Section
      features: {
        title: '平台为什么能持续推进工作',
        subtitle: '核心价值不在于回答更花哨，而在于让任务能被理解、执行、验证和沉淀。',
        cloud: {
          title: '云端理解与统一调度',
          desc: '请求、上下文、模型选择、技能调用和状态管理在同一调度中心中收口。'
        },
        verified: {
          title: '可验证的执行闭环',
          desc: '任务过程可追踪、可中断、可恢复，不让复杂执行变成不可见黑箱。'
        },
        project: {
          title: '项目化长期工作',
          desc: '文件、会话、预览、版本和结果共同沉淀在项目容器里，而不是每次从零开始。'
        },
        crossEnd: {
          title: '跨端节点执行网络',
          desc: 'Windows、Linux 与 Android 节点沿着同一工作主链协同，支撑真实环境中的持续推进。'
        }
      },
      
      companion: {
        title: '艾薇莉亚 3D 桌宠版',
        subtitle: '轻量级桌面伙伴，即将上线',
        desc: '在桌面一角以 3D 形象常驻，随时响应指令，与当前的自动化能力共用同一套内核。',
        hint: '敬请期待，后续将在官网和应用内同步预告。'
      },
      
      // CTA Section
      cta: {
        title: '从一次性提问，走向持续存在的工作系统',
        subtitle: '现在就进入 Avelia，体验目标理解、节点执行与结果沉淀如何在一条链路上发生。',
        downloadBtn: '免费体验',
        hint: '进入 Avelia 工作入口，开始你的第一条持续任务链。'
      }
    },
    
    // Features Page
    features: {
      title: '平台能力编排',
      subtitle: '从会话、任务到节点执行与知识沉淀\nAvelia 不是能力拼盘，而是一套可持续推进工作的系统',
      categories: {
        interaction: {
          title: '会话与任务入口',
          smartChat: { name: '目标理解', desc: '把自然语言转成可推进的任务上下文' },
          taskExec: { name: '任务推进', desc: '围绕目标持续判断下一步动作' },
          autoOpt: { name: '状态收敛', desc: '在执行、阻塞与重规划之间保持闭环' },
          expLearn: { name: '经验沉淀', desc: '把过程与结果沉淀为可复用资产' }
        },
        tools: {
          title: '项目与工作区',
          sysControl: { name: '工作区操作', desc: '读取、修改、预览与导出项目内容' },
          fileOps: { name: '文件级协作', desc: '文件、版本、快照与结果共同沉淀' },
          mediaProc: { name: '内容生产', desc: '图像、视频、音频任务进入统一工作流' },
          network: { name: '环境连接', desc: '网页、接口与远程资源进入同一执行链路' }
        },
        media: {
          title: '创意与产物',
          videoEdit: { name: '视频生成与延展', desc: '让视频任务拥有状态、回看与复用能力' },
          videoFx: { name: '视觉表达', desc: '支撑品牌物料、场景图与动态内容生产' },
          imageProc: { name: '图像工作流', desc: '图像生成、参考图变体与创意迭代' },
          batch: { name: '资产管理', desc: '让生成结果成为长期可调用的创意资产' }
        },
        multimodal: {
          title: '知识与理解',
          ocr: { name: '多模态理解', desc: '文本、图像与结构化内容共同进入上下文' },
          tts: { name: '语音与音频', desc: '把语音生成能力并入统一任务系统' },
          docParse: { name: '文档解析', desc: '文档不只是附件，而是可检索的知识来源' },
          smartInput: { name: '上下文协同', desc: '让输入围绕当前目标持续补全与推进' }
        },
        memory: {
          title: '长期资产层',
          history: { name: '会话记录', desc: '让任务上下文可以延续，而不是请求结束即归零' },
          longTerm: { name: '长期记忆', desc: '保留偏好、重要事实与关键决策' },
          knowledge: { name: '知识库', desc: '项目文档、资料与执行结果统一归档' },
          experience: { name: '经验资产', desc: '让历史工作成为后续任务的加速器' }
        },
        security: {
          title: '控制与安全',
          permission: { name: '权限边界', desc: '明确 AI 在环境中的可执行范围' },
          encryption: { name: '数据保护', desc: '敏感信息在长期工作过程中保持可控' },
          userSys: { name: '用户与角色', desc: '多用户、多角色与协作责任清晰分层' },
          audit: { name: '审计轨迹', desc: '关键动作、结果与状态变化可追溯' }
        },
        models: {
          title: '编排与扩展',
          multiModel: { name: '模型选择', desc: '根据任务类型切换不同理解与生成能力' },
          flexSwitch: { name: '技能调度', desc: '把技能、工具与节点接入同一编排平面' },
          cloudSync: { name: '云端同步', desc: '状态、任务与结果在平台侧统一汇总' },
          tokenMgmt: { name: '能力治理', desc: '从资源使用到订阅策略保持可管理性' }
        }
      },
      stats: {
        tools: '核心结构层',
        mediaFeatures: '主要执行端',
        possibilities: '持续工作链'
      }
    },
    
    // Download Page
    download: {
      title: '节点下载',
      subtitle: '让 Avelia 连接 Windows、Linux 与 Android 的真实执行面',
      loading: '正在获取版本信息...',
      retry: '重试',
      latestStable: '当前稳定通道',
      releaseDate: '同步日期',
      downloadNowBtn: '立即下载节点',
      comingSoonBtn: '节点即将开放',
      fileSize: '当前版本信息',
      updateNotes: '节点说明',
      requirements: {
        title: '节点要求',
        os: { label: '系统支持', value: 'Windows / Linux / Android' },
        storage: { label: '接入方式', value: '节点受控接入并汇报能力' },
        network: { label: '运行前提', value: '稳定连接与可验证的执行回传' }
      },
      steps: {
        title: '节点上线流程',
        step1: { title: '接入节点', desc: '将目标设备纳入 Avelia 的统一调度范围' },
        step2: { title: '汇报能力', desc: '上报可执行技能、平台信息与节点状态' },
        step3: { title: '进入任务链', desc: '让节点参与项目任务、自动化与协作流程' },
        step4: { title: '结果沉淀', desc: '把执行结果回流到项目、知识与历史资产中' }
      },
      faq: {
        title: '常见问题',
        q1: { q: 'Q: 节点到底是什么？', a: 'A: 节点可以理解成 Avelia 进入真实设备和真实环境的执行入口。云端负责理解目标、组织上下文和决定下一步，节点负责在你的电脑、服务器或移动设备上执行动作，并把状态、进度和结果回传回来。' },
        q2: { q: 'Q: 我现在应该下载哪一种节点？', a: 'A: 如果你要处理本机软件、桌面操作、工作区协作或网页改版，优先选择 Windows 节点。若你的核心需求是服务器巡检、部署检查、日志核对、数据库或缓存协助，应该关注 Linux 节点。若你需要移动端界面操作和跨端流程执行，则是 Android 节点。当前稳定通道以 Windows 节点为主，Linux 与 Android 先展示方向，不提供直接下载。' },
        q3: { q: 'Q: 节点接入后是如何工作的？', a: 'A: 一次典型流程是：你先在 Avelia 中提出目标，系统判断这项任务是否需要真实环境执行；如果需要，就把任务调度到合适的节点；节点执行命令、观察界面或处理动作后，再把结果回流到当前会话、项目和知识中。你看到的不只是结论，还会有可回看的执行链。' },
        q4: { q: 'Q: 节点安装后通常能帮我做什么？', a: 'A: Windows 节点更适合桌面应用、本机文件、工作区和日常执行任务；Linux 节点更适合远程环境、命令执行、部署与运维类工作；Android 节点更适合移动界面观察、点击输入和流程推进。你不需要一次把所有节点都装上，而是按你当前最常用的执行面来选择。' },
        q5: { q: 'Q: 节点是否安全？会不会自己乱操作？', a: 'A: 节点不是脱离平台独立运行的黑盒。它需要先绑定接入，平台会看到节点状态、能力和执行结果；高风险任务应当明确权限边界和确认点。更适合的理解是：节点让 Avelia 有能力进入真实环境，但是否执行、执行到哪一步，应该始终围绕你的任务目标、节点能力和确认规则来推进。' }
      }
    },
    
    // Docs Page
    docs: {
      title: '文档中心',
      subtitle: '从入门到精通，一切你需要了解的内容',
      menu: {
        title: '文档导航'
      },
      content: {
        comingSoon: '内容即将上线...',
        
        // ========== 快速开始 ==========
        // 安装指南
        install: {
          title: '安装指南',
          download: {
            title: '下载安装包',
            content: '访问官网下载页面，获取最新版本的 Avelia 安装包。支持 Windows 10/11 64位系统。'
          },
          setup: {
            title: '安装步骤',
            steps: [
              '双击下载的安装包，启动安装向导',
              '选择安装路径（建议使用默认路径）',
              '等待安装完成，首次启动会自动配置环境',
              '使用平台默认模型开始对话，或在设置中添加自定义模型'
            ]
          }
        },
        
        // 基本使用
        basicUse: {
          title: '基本使用',
          modes: {
            title: '两种工作模式',
            content: 'Avelia 提供两种工作模式：\n\n• 聊天模式：自由对话，AI会根据上下文理解你的意图\n• 任务模式：明确的任务指令，AI会调用工具完成具体操作\n\n两种模式可以无缝切换，AI会自动判断何时需要使用工具。'
          },
          chat: {
            title: '聊天模式',
            content: '在聊天模式下，你可以：\n\n• 询问问题："今天天气怎么样？"\n• 寻求建议："如何提高工作效率？"\n• 闲聊交流："讲个笑话吧"\n\nAI会像朋友一样与你对话，理解上下文，记住之前的对话内容。'
          },
          task: {
            title: '任务模式',
            content: '在任务模式下，你可以：\n\n• 文件操作："帮我整理桌面上的文件"\n• 数据处理："把这个Excel表格转换成PDF"\n• 自动化任务："每天早上9点提醒我开会"\n\nAI会自动调用相应的工具，完成你的指令。'
          }
        },
        
        // 配置模型
        configModel: {
          title: '配置模型',
          platform: {
            title: '使用平台模型',
            content: 'Avelia 平台默认提供多种AI模型，开箱即用：\n\n• GPT-4：最强大的通用模型\n• Claude：擅长长文本理解和代码\n• DeepSeek：国产高性价比模型\n• Gemini：Google的多模态模型\n\n无需配置API密钥，直接使用。'
          },
          custom: {
            title: '添加自定义模型',
            steps: [
              '点击设置 → 模型管理',
              '点击"添加模型"按钮',
              '选择模型类型（OpenAI/Claude/Ollama等）',
              '填入API密钥和端点地址',
              '测试连接，保存配置',
              '在对话中切换到自定义模型'
            ]
          }
        },
        
        // ========== 功能教程 ==========
        // 智能对话
        smartChat: {
          title: '智能对话',
          intro: {
            title: '自然语言交互',
            content: 'Avelia 支持自然语言对话，你不需要记住任何命令格式，只需要像和朋友聊天一样描述你的需求。\n\n核心特性：\n• 上下文理解：记住之前的对话内容\n• 意图识别：理解你的真实需求\n• 主动澄清：不确定时会主动询问\n• 多轮对话：支持复杂任务的分步执行'
          },
          tips: {
            title: '对话技巧',
            content: [
              {
                title: '明确具体',
                desc: '描述清楚你的需求，提供必要的上下文信息'
              },
              {
                title: '分步骤',
                desc: '复杂任务可以分成多个步骤，逐步完成'
              },
              {
                title: '提供示例',
                desc: '如果AI不理解，可以提供具体的示例'
              },
              {
                title: '及时反馈',
                desc: '告诉AI结果是否符合预期，帮助它改进'
              }
            ]
          }
        },
        
        // 任务执行
        taskExec: {
          title: '任务执行',
          intro: {
            title: '工具调用机制',
            content: 'Avelia 内置200+工具，涵盖文件操作、系统控制、网络请求、数据处理等各个方面。AI会根据你的需求自动选择合适的工具。\n\n执行流程：\n1. 理解需求：分析你的指令\n2. 规划步骤：制定执行计划\n3. 调用工具：执行具体操作\n4. 验证结果：检查是否成功\n5. 反馈用户：报告执行结果'
          },
          examples: {
            title: '使用示例',
            content: [
              {
                title: '文件整理',
                desc: '"把下载文件夹里的图片都移动到图片文件夹" → AI会扫描文件、识别图片、批量移动'
              },
              {
                title: '数据处理',
                desc: '"把这个CSV文件转换成Excel，并按销售额排序" → AI会读取CSV、转换格式、排序数据'
              },
              {
                title: '网页操作',
                desc: '"打开京东搜索iPhone 15，告诉我最便宜的价格" → AI会打开浏览器、搜索、提取价格'
              }
            ]
          }
        },
        
        // 知识库管理
        knowledge: {
          title: '知识库管理',
          intro: {
            title: '构建个人知识库',
            content: '知识库功能允许你导入文档，构建个人知识库。AI可以实时搜索知识库内容，回答基于你的文档的问题。\n\n支持的文档格式：\n• 文本文件：txt、md\n• 办公文档：pdf、docx、xlsx、pptx\n• 代码文件：py、js、java、cpp等\n• 网页文件：html、xml'
          },
          import: {
            title: '导入文档',
            steps: [
              '点击"知识库"标签页',
              '点击"导入文档"按钮',
              '选择要导入的文件或文件夹',
              '等待AI解析和索引文档',
              '导入完成后可以立即搜索'
            ]
          },
          search: {
            title: '搜索知识',
            content: '在对话中，AI会自动搜索知识库：\n\n• 直接提问："我的项目文档里提到了哪些技术栈？"\n• 引用内容："根据我的笔记，上次会议的结论是什么？"\n• 对比分析："对比一下方案A和方案B的优缺点"\n\nAI会返回相关内容，并注明来源文档。'
          }
        },
        
        // 自定义指令
        customCmd: {
          title: '自定义指令',
          intro: {
            title: '个性化AI行为',
            content: '自定义指令允许你为AI设置个性化的行为规则和背景知识。这些指令会在每次对话中生效，让AI更符合你的使用习惯。\n\n应用场景：\n• 角色设定："你是一个资深的Python开发工程师"\n• 输出格式："回答时使用Markdown格式"\n• 工作流程："在执行任务前，先列出执行计划"\n• 专业领域："你熟悉金融行业的业务流程"'
          },
          usage: {
            title: '设置自定义指令',
            steps: [
              '点击设置 → 自定义指令',
              '在"系统指令"框中输入你的要求',
              '可以设置多条指令，每条一行',
              '保存后立即生效',
              '可以为不同的Agent设置不同的指令'
            ]
          }
        },
        
        // 记忆管理
        memory: {
          title: '记忆管理',
          intro: {
            title: '长期记忆系统',
            content: 'Avelia 具备长期记忆能力，可以记住重要信息并在未来的对话中使用。记忆分为三个层次：\n\n• 对话历史：完整的消息记录\n• 短期记忆：当前会话的上下文\n• 长期记忆：重要信息和用户偏好\n\n所有记忆数据存储在本地，完全由你掌控。'
          },
          manage: {
            title: '管理记忆',
            content: [
              {
                title: '查看记忆',
                desc: '在"记忆"标签页查看所有已保存的记忆条目'
              },
              {
                title: '添加记忆',
                desc: '对话中说"记住这个信息"，AI会将其保存到长期记忆'
              },
              {
                title: '编辑记忆',
                desc: '点击记忆条目可以编辑或删除'
              },
              {
                title: '清空记忆',
                desc: '可以选择清空对话历史或长期记忆'
              }
            ]
          }
        },
        
        // 群组协作
        groupChat: {
          title: '群组协作',
          intro: {
            title: '什么是群组协作？',
            content: '群组协作允许你创建多个 AI Agent 组成的工作组，让它们协同完成复杂任务。每个 Agent 可以有不同的角色和专长，通过 @提及 机制进行交互，实现高效的多角色协作。\n\n适用场景：\n• 软件开发项目（产品经理 + 架构师 + 程序员 + 测试工程师）\n• 内容创作（策划 + 撰稿 + 编辑 + 审核）\n• 数据分析（数据采集 + 清洗 + 分析 + 可视化）'
          },
          create: {
            title: '创建群组',
            steps: [
              '在主界面点击"群组"标签页',
              '点击"创建群组"按钮',
              '输入群组名称（如"软件开发团队"）',
              '选择要加入群组的 Agent（至少2个）',
              '可选：设置工作区路径，所有 Agent 将在此目录下工作',
              '点击"创建"完成'
            ]
          },
          config: {
            title: '成员配置',
            content: '创建群组后，可以配置每个成员的权限：\n\n• 发言权限：控制该成员是否可以主动发言\n• 监听对象：设置该成员监听哪些成员的消息（默认只监听用户）\n• 负责人标记：指定群组负责人，负责协调和决策\n\n通过 @成员名 可以直接向特定成员发送消息，被 @ 的成员会收到通知并响应。'
          },
          usage: {
            title: '使用群组',
            content: '在群组聊天界面：\n\n1. 直接发送消息：所有成员都会看到\n2. @特定成员：只有被 @ 的成员会响应\n3. @多个成员：按顺序响应，实现协作流程\n\n示例：\n"@产品经理 我们需要开发一个用户管理系统"\n"@架构师 请根据需求设计系统架构"\n"@程序员 按照架构文档开始编码"'
          }
        },
        
        // 跨平台通道
        channels: {
          title: '跨平台通道',
          intro: {
            title: '什么是跨平台通道？',
            content: '跨平台通道允许你通过 Telegram、飞书、微信小程序等平台远程控制你的 Avelia 助手。无论你在哪里，都可以向电脑上的 AI 发送指令，让它帮你完成任务。\n\n支持的通道：\n• Telegram Bot（全球用户推荐）\n• 飞书机器人（企业用户推荐）\n• 微信小程序（国内用户推荐）'
          },
          telegram: {
            title: '配置 Telegram',
            steps: [
              '在 Telegram 中搜索 @BotFather',
              '发送 /newbot 创建新机器人',
              '按提示设置机器人名称和用户名',
              '获取 API Token（格式：123456:ABC-DEF...）',
              '在 Avelia 设置中找到"通道配置"',
              '启用 Telegram，粘贴 API Token',
              '保存配置，在 Telegram 中搜索你的机器人并开始对话'
            ]
          },
          feishu: {
            title: '配置飞书',
            steps: [
              '访问飞书开放平台（open.feishu.cn）',
              '创建企业自建应用',
              '获取 App ID 和 App Secret',
              '配置机器人权限（接收消息、发送消息）',
              '在 Avelia 设置中启用飞书通道',
              '填入 App ID、App Secret 和欢迎群 ID',
              '保存配置，在飞书中添加机器人到群聊'
            ]
          },
          wechat: {
            title: '微信小程序',
            content: '微信小程序通道默认启用，无需额外配置。\n\n使用方法：\n1. 在微信中搜索"Avelia助手"小程序\n2. 扫码绑定你的电脑客户端\n3. 在小程序中发送消息，电脑上的 AI 会自动响应\n4. 支持文本、图片、文件等多种消息类型'
          }
        },
        
        // 浏览器自动化
        browserAuto: {
          title: '浏览器自动化',
          intro: {
            title: '强大的网页操作能力',
            content: 'Avelia 内置 Chrome 自动化驱动，提供 29 个专业工具，可以像人类一样操作浏览器。基于 Chrome DevTools Protocol，支持无头模式和有头模式。\n\n核心优势：\n• 智能元素识别：自动定位按钮、输入框、链接等元素\n• 动态页面适应：处理 AJAX、SPA 等现代网页\n• 反爬虫绕过：模拟真实用户行为\n• 截图和录制：记录操作过程'
          },
          tools: {
            title: '主要工具分类',
            content: [
              {
                title: '页面导航',
                desc: '打开网页、前进后退、刷新、等待加载、关闭标签页'
              },
              {
                title: '元素操作',
                desc: '点击、输入文本、选择下拉框、上传文件、拖拽元素'
              },
              {
                title: '数据提取',
                desc: '获取文本、属性、HTML、表格数据、链接列表'
              },
              {
                title: '页面交互',
                desc: '滚动、截图、执行 JavaScript、切换 iframe、处理弹窗'
              },
              {
                title: '高级功能',
                desc: '等待元素出现、监听网络请求、设置 Cookie、模拟移动设备'
              }
            ]
          },
          examples: {
            title: '使用示例',
            content: '示例1：自动登录网站\n"打开 example.com，在用户名框输入 admin，在密码框输入 123456，点击登录按钮"\n\n示例2：数据采集\n"打开京东搜索 iPhone 15，提取前10个商品的标题、价格和评论数"\n\n示例3：自动填表\n"打开报名表单，填写姓名、手机号、邮箱，上传身份证照片，提交表单"\n\nAI 会自动分解任务，调用相应的工具完成操作。'
          }
        },
        
        // 任务管理系统
        taskSystem: {
          title: '任务管理系统',
          intro: {
            title: '企业级任务调度',
            content: 'Avelia 内置完整的任务管理系统，支持任务调度、依赖管理、失败重试、并发控制等企业级特性。基于 ReAct Loop 架构，每个任务都是一个独立的执行单元。'
          },
          features: {
            title: '核心特性',
            content: [
              {
                title: '任务调度',
                desc: '支持立即执行、延迟执行、定时执行、周期执行'
              },
              {
                title: '依赖管理',
                desc: '任务可以依赖其他任务，自动按依赖顺序执行'
              },
              {
                title: '失败重试',
                desc: '任务失败后自动重试，支持指数退避策略'
              },
              {
                title: '并发控制',
                desc: '限制同时执行的任务数量，避免资源耗尽'
              },
              {
                title: '状态追踪',
                desc: '实时查看任务状态：等待、运行、成功、失败、取消'
              }
            ]
          },
          usage: {
            title: '使用方法',
            steps: [
              '在对话中描述你的任务需求',
              'AI 会自动创建任务并加入队列',
              '任务按优先级和依赖关系执行',
              '可以在"任务"标签页查看所有任务状态',
              '支持手动取消、重试、删除任务'
            ]
          }
        },
        
        // 多Agent代理
        multiAgent: {
          title: '多Agent代理系统',
          intro: {
            title: '协同工作的AI团队',
            content: '多Agent系统允许多个AI同时工作，每个Agent可以有不同的模型、指令和工具权限。通过Agent Manager统一管理，支持动态创建、配置和调度。\n\n应用场景：\n• 复杂任务分解：将大任务拆分给多个专业Agent\n• 并行处理：多个Agent同时处理不同子任务\n• 专业分工：不同Agent负责不同领域（代码、文档、测试）'
          },
          workflow: {
            title: '工作流程',
            content: '1. 创建Agent：在"Agent管理"中创建新Agent，配置名称、模型、系统指令\n2. 分配任务：通过群组或直接调用，将任务分配给特定Agent\n3. 协同执行：多个Agent可以相互调用，共享上下文\n4. 结果汇总：主Agent收集各个子Agent的结果，整合后返回\n\n示例：软件开发流程\n• 需求分析Agent：理解用户需求，输出需求文档\n• 架构设计Agent：根据需求设计系统架构\n• 编码Agent：按照架构编写代码\n• 测试Agent：编写测试用例并执行测试'
          }
        },
        
        // MCP协议
        mcpProtocol: {
          title: 'MCP协议扩展',
          intro: {
            title: '什么是MCP？',
            content: 'Model Context Protocol（模型上下文协议）是一个开放标准，用于AI应用与外部工具的集成。Avelia 完全支持MCP协议，可以轻松接入社区开发的各种工具和服务。\n\n优势：\n• 开放生态：使用社区开发的数千个MCP工具\n• 标准化：统一的接口规范，易于集成\n• 可扩展：开发者可以轻松创建自定义工具'
          },
          usage: {
            title: '如何使用MCP工具',
            content: '1. 安装MCP服务器\n在设置中找到"MCP配置"，添加MCP服务器地址。支持本地服务器和远程服务器。\n\n2. 配置工具权限\n为每个MCP工具配置访问权限，确保安全性。\n\n3. 在对话中使用\nAI会自动识别可用的MCP工具，并在需要时调用。\n\n示例MCP工具：\n• 数据库查询工具\n• API调用工具\n• 文件同步工具\n• 第三方服务集成'
          }
        },
        
        // 功能驱动
        drivers: {
          title: '丰富的功能驱动',
          intro: {
            title: '全面的系统能力',
            content: 'Avelia 内置27个功能驱动，涵盖桌面控制、文档处理、媒体编辑、网络通信等各个方面。每个驱动提供多个工具，总计超过200个可用工具。'
          },
          categories: {
            title: '驱动分类',
            content: [
              {
                title: '桌面控制',
                desc: '鼠标键盘、窗口管理、进程控制、剪贴板、截图、音频、显示器'
              },
              {
                title: '文档处理',
                desc: 'PDF操作、Word编辑、Excel处理、文件系统、知识库搜索'
              },
              {
                title: '媒体编辑',
                desc: '视频剪辑、图片处理、格式转换'
              },
              {
                title: '网络通信',
                desc: '浏览器自动化、HTTP请求、WebSocket、邮件发送'
              },
              {
                title: '系统工具',
                desc: 'PowerShell、注册表、系统信息、环境变量、任务计划'
              },
              {
                title: 'AI能力',
                desc: 'OCR识别、语音合成、语音识别'
              }
            ]
          }
        },
        
        // 权限管理
        permission: {
          title: '权限管理',
          intro: {
            title: '精细化权限控制',
            content: 'Avelia 提供工具级别的权限管理，你可以控制AI能使用哪些工具，确保系统安全。\n\n权限级别：\n• 允许：AI可以自由使用该工具\n• 询问：使用前需要你确认\n• 禁止：AI无法使用该工具\n\n推荐配置：\n• 文件读取：允许\n• 文件写入/删除：询问\n• 系统命令：询问\n• 网络请求：允许'
          },
          config: {
            title: '配置权限',
            steps: [
              '点击设置 → 权限管理',
              '查看所有可用工具列表',
              '为每个工具设置权限级别',
              '可以按分类批量设置',
              '保存配置后立即生效',
              '可以随时调整权限设置'
            ]
          }
        },
        
        // 问题排查
        troubleshooting: {
          title: '问题排查',
          common: {
            title: '常见问题',
            content: [
              {
                title: 'AI无法调用工具',
                desc: '检查权限设置，确保工具权限为"允许"或"询问"。查看日志了解具体错误信息。'
              },
              {
                title: '模型响应慢',
                desc: '可能是网络问题或模型服务器负载高。尝试切换到其他模型，或使用本地Ollama模型。'
              },
              {
                title: '知识库搜索不准确',
                desc: '重新索引知识库，确保文档格式正确。使用更具体的搜索关键词。'
              },
              {
                title: '浏览器自动化失败',
                desc: '确保Chrome浏览器已安装。检查网页是否有反爬虫机制。尝试降低操作速度。'
              },
              {
                title: '群组成员不响应',
                desc: '检查成员的监听配置，确保设置了正确的监听对象。使用@提及确保成员收到消息。'
              }
            ]
          }
        },
        
        // 其他说明
        otherNotes: {
          title: '其他说明',
          concepts: {
            title: '驱动与技能的区别',
            content: [
              {
                title: '驱动（Driver）',
                desc: '底层能力模块，提供基础工具集。涵盖桌面控制、文件操作、媒体处理、网络通信等各个方面。驱动是AI调用的基础能力单元，类似于"工具箱"。'
              },
              {
                title: '技能（Skill）',
                desc: '高级业务逻辑封装，基于驱动实现特定功能。例如"抖音评论寻找"技能会调用浏览器驱动、文件驱动等多个底层驱动来完成复杂的自动化任务。技能是面向用户的完整解决方案，类似于"使用工具箱完成的具体工作"。'
              }
            ]
          }
        }
      },
      quickLinks: {
        manual: '用户手册',
        guide: '功能指南',
        bestPractice: '最佳实践',
        help: '获取帮助'
      },
      sections: {
        quickStart: {
          title: '快速开始',
          install: { name: '安装指南', desc: '如何安装和首次配置 Avelia' },
          basicUse: { name: '基本使用', desc: '了解聊天模式和任务模式' },
          configModel: { name: '配置模型', desc: '添加和管理AI模型' }
        },
        tutorials: {
          title: '功能教程',
          smartChat: { name: '智能对话', desc: '如何与 Avelia 进行自然对话' },
          taskExec: { name: '任务执行', desc: '使用工具完成复杂任务' },
          knowledge: { name: '知识库管理', desc: '导入文档，构建知识库' },
          customCmd: { name: '自定义指令', desc: '为模型添加个性化指令' },
          memory: { name: '记忆管理', desc: '管理长期记忆和对话历史' },
          groupChat: { name: '群组协作', desc: '创建多Agent群组，协同完成任务' },
          channels: { name: '跨平台通道', desc: '通过Telegram/飞书/微信远程控制' },
          browserAuto: { name: '浏览器自动化', desc: '丰富的工具实现智能网页操作' },
          taskSystem: { name: '任务管理', desc: '任务调度、依赖管理、失败重试' }
        },
        advanced: {
          title: '高级功能',
          permission: { name: '权限管理', desc: '工具权限配置和安全设置' },
          multiAgent: { name: '多Agent代理', desc: '多个AI协同工作，提升效率' },
          mcpProtocol: { name: 'MCP协议', desc: '扩展自定义功能驱动' },
          drivers: { name: '丰富的驱动', desc: '涵盖桌面控制、文档处理、媒体编辑等' }
        },
        faq: {
          title: '常见问题',
          troubleshooting: { name: '问题排查', desc: '解决使用过程中的常见问题' },
          otherNotes: { name: '其他说明', desc: '驱动、技能、工具等基本概念说明' }
        }
      },
      helpSection: {
        title: '找不到你需要的内容？',
        subtitle: '我们随时准备帮助你解决问题',
        contactSupport: '联系支持',
        joinCommunity: '加入社区'
      }
    },
    
    // Footer
    footer: {
        tagline: 'Avelia 让智能从屏幕里的回答延伸到项目、设备与真实环境，形成一套持续向前的工作系统。',
        product: {
          title: '产品',
          features: '平台能力',
          download: '节点下载',
          docs: '文档中心',
          openCenter: '开放中心'
        },
      support: {
        title: '支持',
        help: '帮助中心',
        community: '社区',
        feedback: '反馈',
        contact: '联系我们'
      },
      copyright: '© 2026 安徽灵元机器人科技有限公司 版权所有',
      status: {
        timeline: '平台状态',
        stable: '持续运行',
        mission: '节点网络',
        active: '扩展中'
      }
    }
  },
  
  en: {
    // Navbar
    nav: {
        home: 'Home',
        features: 'Platform',
        download: 'Node Downloads',
        docs: 'Docs',
        openCenter: 'Open Center',
        downloadBtn: 'Start Now'
    },
    
    // Home Page
    home: {
      // Hero Section
        hero: {
          status: 'Avelia Runtime Live',
          feature1: 'Cloud understanding · Unified orchestration',
          feature2: 'Local execution · Verifiable progress',
          feature3: 'Knowledge assets · Long-term reuse',
          title: 'Bring every intention into the real world',
          subtitle: 'Intelligence that moves across projects, devices, and environments',
          description: 'A platform designed for continuous creation, long-horizon collaboration, and cross-end execution',
          downloadBtn: 'Try for Free',
          featuresBtn: 'See the Platform'
        },
      
      // Capabilities Section
      capabilities: {
        title: 'The Avelia work chain',
        subtitle: 'Avelia does not stack isolated tools. It connects understanding, execution, and accumulation into one continuous system.',
        conversation: {
          title: 'Conversation Layer',
          subtitle: 'Intent entry point',
          desc: 'Users express goals, add context, and stay close to progress through natural language.'
        },
        task: {
          title: 'Task Layer',
          subtitle: 'Runnable work objects',
          desc: 'Each request becomes a stateful process with next actions, completion criteria, and blockers.'
        },
        knowledge: {
          title: 'Knowledge Layer',
          subtitle: 'Long-term assets',
          desc: 'Chats, projects, documents, and results accumulate into reusable context for future work.'
        },
        node: {
          title: 'Node Layer',
          subtitle: 'Real execution surfaces',
          desc: 'Desktop, server, and mobile nodes let AI step into environments, execute actions, and return outcomes.'
        }
      },
      
      // Features Section
      features: {
        title: 'Why the platform keeps work moving',
        subtitle: 'The advantage is not louder answers. It is a system that can understand, execute, verify, and retain progress.',
        cloud: {
          title: 'Cloud-side understanding and orchestration',
          desc: 'Requests, context, model selection, skill routing, and state management converge inside one control plane.'
        },
        verified: {
          title: 'Verifiable execution loops',
          desc: 'Tasks remain traceable, interruptible, and resumable so complex work does not disappear into a black box.'
        },
        project: {
          title: 'Project-based continuous work',
          desc: 'Files, previews, versions, and conversations stay together so work does not reset every time.'
        },
        crossEnd: {
          title: 'Cross-end node execution',
          desc: 'Windows, Linux, and Android nodes operate along one work chain for real-world, multi-surface execution.'
        }
      },
      
      companion: {
        title: 'Avelia 3D Desktop Companion',
        subtitle: 'Lightweight 3D companion, coming soon',
        desc: 'A small 3D Avelia living on your desktop, sharing the same automation core and ready to respond to your commands.',
        hint: 'Stay tuned for previews on the website and inside the app.'
      },
      
      // CTA Section
      cta: {
        title: 'Move from one-off prompts to a persistent work system',
        subtitle: 'Enter Avelia now and experience goal understanding, node execution, and result accumulation on one chain.',
        downloadBtn: 'Try for Free',
        hint: 'Enter the Avelia workspace and start your first continuous task flow.'
      }
    },
    
    // Features Page
    features: {
      title: 'Platform Capabilities',
      subtitle: 'From conversation and task progression to node execution and knowledge accumulation\nAvelia is a working system, not a pile of isolated features',
      categories: {
        interaction: {
          title: 'Conversation and task entry',
          smartChat: { name: 'Intent Understanding', desc: 'Turn natural language into actionable work context' },
          taskExec: { name: 'Task Progression', desc: 'Keep deciding the next meaningful action around the goal' },
          autoOpt: { name: 'State Convergence', desc: 'Move cleanly between execution, blocking, and replanning' },
          expLearn: { name: 'Experience Assets', desc: 'Preserve process and outcomes for future reuse' }
        },
        tools: {
          title: 'Projects and workspace',
          sysControl: { name: 'Workspace Operations', desc: 'Read, modify, preview, and export project content' },
          fileOps: { name: 'File-Level Collaboration', desc: 'Files, versions, snapshots, and outputs stay together' },
          mediaProc: { name: 'Content Production', desc: 'Image, video, and audio tasks enter one execution flow' },
          network: { name: 'Environment Access', desc: 'Web, APIs, and remote resources join the same work chain' }
        },
        media: {
          title: 'Creative output',
          videoEdit: { name: 'Video Generation', desc: 'Treat generation, variation, and extension as trackable work' },
          videoFx: { name: 'Visual Expression', desc: 'Support brand materials, concept visuals, and motion assets' },
          imageProc: { name: 'Image Workflows', desc: 'Generate, refine, and iterate visual directions in context' },
          batch: { name: 'Asset Management', desc: 'Keep creative outcomes reusable across future tasks' }
        },
        multimodal: {
          title: 'Knowledge and understanding',
          ocr: { name: 'Multimodal Understanding', desc: 'Text, images, and structured content all become context' },
          tts: { name: 'Voice and Audio', desc: 'Bring speech generation into the same task system' },
          docParse: { name: 'Document Parsing', desc: 'Documents become searchable context rather than dead attachments' },
          smartInput: { name: 'Context Collaboration', desc: 'Inputs keep enriching the active objective' }
        },
        memory: {
          title: 'Long-term asset layer',
          history: { name: 'Conversation History', desc: 'Keep task context alive instead of resetting every request' },
          longTerm: { name: 'Long-term Memory', desc: 'Retain preferences, facts, and key decisions' },
          knowledge: { name: 'Knowledge Base', desc: 'Archive project docs, references, and execution outcomes' },
          experience: { name: 'Experience Assets', desc: 'Let past work accelerate future tasks' }
        },
        security: {
          title: 'Control and safety',
          permission: { name: 'Permission Boundaries', desc: 'Define what AI can and cannot do in an environment' },
          encryption: { name: 'Data Protection', desc: 'Keep sensitive information controlled throughout long-running work' },
          userSys: { name: 'Users and Roles', desc: 'Clarify responsibility across multi-user and multi-role collaboration' },
          audit: { name: 'Audit Trails', desc: 'Track actions, outcomes, and state transitions end to end' }
        },
        models: {
          title: 'Orchestration and extension',
          multiModel: { name: 'Model Selection', desc: 'Use the right reasoning or generation layer for each task' },
          flexSwitch: { name: 'Skill Routing', desc: 'Bring skills, tools, and nodes into one orchestration plane' },
          cloudSync: { name: 'Cloud Synchronization', desc: 'Aggregate task state and outcomes on the platform side' },
          tokenMgmt: { name: 'Capability Governance', desc: 'Manage resources, subscriptions, and platform growth cleanly' }
        }
      },
      stats: {
        tools: 'Core layers',
        mediaFeatures: 'Execution surfaces',
        possibilities: 'Work chain'
      }
    },
    
    // Download Page
    download: {
      title: 'Node Downloads',
      subtitle: 'Connect Avelia to real execution surfaces across Windows, Linux, and Android',
      loading: 'Fetching version information...',
      retry: 'Retry',
      latestStable: 'Stable channel',
      releaseDate: 'Synced on',
      downloadNowBtn: 'Download node now',
      comingSoonBtn: 'Node access coming soon',
      fileSize: 'Current version data',
      updateNotes: 'Node notes',
      requirements: {
        title: 'Node requirements',
        os: { label: 'Supported systems', value: 'Windows / Linux / Android' },
        storage: { label: 'Connection model', value: 'Nodes onboard under controlled capability reporting' },
        network: { label: 'Runtime needs', value: 'Stable connectivity with verifiable execution callbacks' }
      },
      steps: {
        title: 'How nodes come online',
        step1: { title: 'Attach a node', desc: 'Bring the target device into Avelia\'s orchestration range' },
        step2: { title: 'Report capabilities', desc: 'Send back supported skills, platform details, and node status' },
        step3: { title: 'Join the work chain', desc: 'Let the node participate in tasks, projects, and automation flows' },
        step4: { title: 'Compound the outcome', desc: 'Return execution results into projects, history, and knowledge' }
      },
      faq: {
        title: 'FAQ',
        q1: { q: 'Q: What is a node, exactly?', a: 'A: A node is the execution entry that lets Avelia step into a real device or environment. The cloud side understands the goal, organizes context, and decides the next move. The node performs actions on your desktop, server, or mobile device, then returns status, progress, and outcomes back into the platform.' },
        q2: { q: 'Q: Which node should I choose right now?', a: 'A: Choose the Windows node when your work depends on local software, desktop actions, workspace collaboration, or web project execution on your machine. Follow the Linux node when your main need is server inspection, deployment checks, logs, databases, caches, or remote operations. Choose the Android direction when you need mobile UI actions and cross-end task flows. Today, the stable channel is centered on Windows, while Linux and Android are shown as upcoming directions without direct download.' },
        q3: { q: 'Q: How do nodes actually work after onboarding?', a: 'A: A typical chain looks like this: you define the goal inside Avelia, the system decides whether real-environment execution is needed, the task is routed to a suitable node, and that node executes commands, observes interfaces, or performs actions. The result then flows back into the active conversation, projects, and knowledge so the execution path remains reviewable.' },
        q4: { q: 'Q: What can a node usually help me do?', a: 'A: Windows nodes are best for desktop apps, local files, workspace tasks, and day-to-day execution. Linux nodes are best for remote environments, command execution, deployment work, and operations-heavy tasks. Android nodes are best for mobile UI observation, taps, input, and flow execution. You do not need every node at once. Start with the execution surface you use most.' },
        q5: { q: 'Q: Is it safe? Can a node act on its own?', a: 'A: A node is not a detached black box acting outside the platform. It must be bound first, and the platform can see node status, capability reports, and execution outcomes. For high-risk tasks, permission boundaries and confirmation points should be made explicit. The better mental model is: nodes give Avelia access to real environments, but how far execution goes should always follow your task goal, the node capability set, and your confirmation rules.' }
      }
    },
    
    // Docs Page
    docs: {
      title: 'Documentation Center',
      subtitle: 'From beginner to expert, everything you need to know',
      menu: {
        title: 'Documentation'
      },
      content: {
        comingSoon: 'Content coming soon...',
        
        // Installation Guide
        install: {
          title: 'Installation Guide',
          download: {
            title: 'Download Installer',
            content: 'Visit the official download page to get the latest version of Avelia installer. Supports Windows 10/11 64-bit systems.'
          },
          setup: {
            title: 'Installation Steps',
            steps: [
              'Double-click the downloaded installer to start the setup wizard',
              'Choose installation path (default path recommended)',
              'Wait for installation to complete, first launch will auto-configure environment',
              'Use platform default models to start chatting, or add custom models in settings'
            ]
          }
        },
        
        // Group Collaboration
        groupChat: {
          title: 'Group Collaboration',
          intro: {
            title: 'What is Group Collaboration?',
            content: 'Group collaboration allows you to create workgroups composed of multiple AI Agents to collaboratively complete complex tasks. Each Agent can have different roles and expertise, interacting through @mention mechanism for efficient multi-role collaboration.\n\nUse Cases:\n• Software development projects (Product Manager + Architect + Developer + QA Engineer)\n• Content creation (Planner + Writer + Editor + Reviewer)\n• Data analysis (Collection + Cleaning + Analysis + Visualization)'
          },
          create: {
            title: 'Create Group',
            steps: [
              'Click "Groups" tab in main interface',
              'Click "Create Group" button',
              'Enter group name (e.g., "Software Dev Team")',
              'Select Agents to join the group (at least 2)',
              'Optional: Set workspace path where all Agents will work',
              'Click "Create" to finish'
            ]
          },
          config: {
            title: 'Member Configuration',
            content: 'After creating a group, you can configure permissions for each member:\n\n• Speaking Permission: Control whether the member can speak proactively\n• Listen To: Set which members this member listens to (default: user only)\n• Leader Mark: Designate group leader for coordination and decision-making\n\nUse @member_name to send messages directly to specific members. Mentioned members will be notified and respond.'
          },
          usage: {
            title: 'Using Groups',
            content: 'In group chat interface:\n\n1. Send message directly: All members will see it\n2. @specific member: Only mentioned member will respond\n3. @multiple members: Respond in order, enabling collaborative workflow\n\nExample:\n"@Product_Manager We need to develop a user management system"\n"@Architect Please design system architecture based on requirements"\n"@Developer Start coding according to architecture docs"'
          }
        },
        
        // Cross-Platform Channels
        channels: {
          title: 'Cross-Platform Channels',
          intro: {
            title: 'What are Cross-Platform Channels?',
            content: 'Cross-platform channels allow you to remotely control your Avelia assistant through Telegram, Feishu, WeChat Mini Program, etc. Wherever you are, you can send commands to the AI on your computer and have it complete tasks.\n\nSupported Channels:\n• Telegram Bot (recommended for global users)\n• Feishu Bot (recommended for enterprise users)\n• WeChat Mini Program (recommended for Chinese users)'
          },
          telegram: {
            title: 'Configure Telegram',
            steps: [
              'Search for @BotFather in Telegram',
              'Send /newbot to create a new bot',
              'Follow prompts to set bot name and username',
              'Get API Token (format: 123456:ABC-DEF...)',
              'Find "Channel Configuration" in Avelia settings',
              'Enable Telegram and paste API Token',
              'Save configuration, search for your bot in Telegram and start chatting'
            ]
          },
          feishu: {
            title: 'Configure Feishu',
            steps: [
              'Visit Feishu Open Platform (open.feishu.cn)',
              'Create enterprise self-built app',
              'Get App ID and App Secret',
              'Configure bot permissions (receive messages, send messages)',
              'Enable Feishu channel in Avelia settings',
              'Fill in App ID, App Secret, and welcome chat ID',
              'Save configuration, add bot to group chat in Feishu'
            ]
          },
          wechat: {
            title: 'WeChat Mini Program',
            content: 'WeChat Mini Program channel is enabled by default, no additional configuration needed.\n\nHow to use:\n1. Search for "Avelia Assistant" mini program in WeChat\n2. Scan QR code to bind your desktop client\n3. Send messages in mini program, AI on your computer will auto-respond\n4. Supports text, images, files, and other message types'
          }
        },
        
        // Browser Automation
        browserAuto: {
          title: 'Browser Automation',
          intro: {
            title: 'Powerful Web Operation Capabilities',
            content: 'Avelia has built-in Chrome automation driver with 29 professional tools that can operate browsers like humans. Based on Chrome DevTools Protocol, supports both headless and headed modes.\n\nCore Advantages:\n• Smart Element Recognition: Auto-locate buttons, input fields, links, etc.\n• Dynamic Page Adaptation: Handle AJAX, SPA, and modern web pages\n• Anti-Scraping Bypass: Simulate real user behavior\n• Screenshot & Recording: Record operation process'
          },
          tools: {
            title: 'Main Tool Categories',
            content: [
              {
                title: 'Page Navigation',
                desc: 'Open page, forward/back, refresh, wait for load, close tab'
              },
              {
                title: 'Element Operations',
                desc: 'Click, input text, select dropdown, upload file, drag element'
              },
              {
                title: 'Data Extraction',
                desc: 'Get text, attributes, HTML, table data, link lists'
              },
              {
                title: 'Page Interaction',
                desc: 'Scroll, screenshot, execute JavaScript, switch iframe, handle popups'
              },
              {
                title: 'Advanced Features',
                desc: 'Wait for element, monitor network requests, set cookies, simulate mobile devices'
              }
            ]
          },
          examples: {
            title: 'Usage Examples',
            content: 'Example 1: Auto Login\n"Open example.com, enter admin in username field, enter 123456 in password field, click login button"\n\nExample 2: Data Collection\n"Open JD.com, search for iPhone 15, extract title, price, and review count of first 10 products"\n\nExample 3: Auto Form Filling\n"Open registration form, fill in name, phone, email, upload ID photo, submit form"\n\nAI will automatically break down tasks and call appropriate tools to complete operations.'
          }
        },
        
        // Task Management System
        taskSystem: {
          title: 'Task Management System',
          intro: {
            title: 'Enterprise-Grade Task Scheduling',
            content: 'Avelia has a complete built-in task management system supporting task scheduling, dependency management, failure retry, concurrency control, and other enterprise-grade features. Based on ReAct Loop architecture, each task is an independent execution unit.'
          },
          features: {
            title: 'Core Features',
            content: [
              {
                title: 'Task Scheduling',
                desc: 'Supports immediate, delayed, scheduled, and periodic execution'
              },
              {
                title: 'Dependency Management',
                desc: 'Tasks can depend on other tasks, auto-execute in dependency order'
              },
              {
                title: 'Failure Retry',
                desc: 'Auto-retry on task failure, supports exponential backoff strategy'
              },
              {
                title: 'Concurrency Control',
                desc: 'Limit concurrent task count to avoid resource exhaustion'
              },
              {
                title: 'Status Tracking',
                desc: 'Real-time task status: waiting, running, success, failed, cancelled'
              }
            ]
          },
          usage: {
            title: 'How to Use',
            steps: [
              'Describe your task requirements in conversation',
              'AI will auto-create task and add to queue',
              'Tasks execute by priority and dependency order',
              'View all task statuses in "Tasks" tab',
              'Support manual cancel, retry, delete tasks'
            ]
          }
        },
        
        // Multi-Agent System
        multiAgent: {
          title: 'Multi-Agent System',
          intro: {
            title: 'Collaborative AI Team',
            content: 'Multi-Agent system allows multiple AIs to work simultaneously, each Agent can have different models, instructions, and tool permissions. Unified management through Agent Manager, supports dynamic creation, configuration, and scheduling.\n\nApplication Scenarios:\n• Complex task decomposition: Split large tasks to specialized Agents\n• Parallel processing: Multiple Agents handle different subtasks simultaneously\n• Professional division: Different Agents for different domains (code, docs, testing)'
          },
          workflow: {
            title: 'Workflow',
            content: '1. Create Agent: Create new Agent in "Agent Management", configure name, model, system instructions\n2. Assign Tasks: Assign tasks to specific Agents through groups or direct calls\n3. Collaborative Execution: Multiple Agents can call each other, share context\n4. Result Aggregation: Main Agent collects results from sub-Agents, integrates and returns\n\nExample: Software Development Process\n• Requirements Analysis Agent: Understand user needs, output requirements doc\n• Architecture Design Agent: Design system architecture based on requirements\n• Coding Agent: Write code according to architecture\n• Testing Agent: Write test cases and execute tests'
          }
        },
        
        // MCP Protocol
        mcpProtocol: {
          title: 'MCP Protocol Extension',
          intro: {
            title: 'What is MCP?',
            content: 'Model Context Protocol is an open standard for integrating AI applications with external tools. Avelia fully supports MCP protocol, easily integrating thousands of community-developed tools and services.\n\nAdvantages:\n• Open Ecosystem: Use thousands of MCP tools developed by community\n• Standardization: Unified interface specification, easy to integrate\n• Extensibility: Developers can easily create custom tools'
          },
          usage: {
            title: 'How to Use MCP Tools',
            content: '1. Install MCP Server\nFind "MCP Configuration" in settings, add MCP server address. Supports local and remote servers.\n\n2. Configure Tool Permissions\nConfigure access permissions for each MCP tool to ensure security.\n\n3. Use in Conversation\nAI will auto-recognize available MCP tools and call them when needed.\n\nExample MCP Tools:\n• Database query tools\n• API calling tools\n• File sync tools\n• Third-party service integrations'
          }
        },
        
        // Function Drivers
        drivers: {
          title: 'Rich Function Drivers',
          intro: {
            title: 'Comprehensive System Capabilities',
            content: 'Avelia has 27 built-in function drivers covering desktop control, document processing, media editing, network communication, and more. Each driver provides multiple tools, totaling over 200 available tools.'
          },
          categories: {
            title: 'Driver Categories',
            content: [
              {
                title: 'Desktop Control',
                desc: 'Mouse & keyboard, window management, process control, clipboard, screenshot, audio, display'
              },
              {
                title: 'Document Processing',
                desc: 'PDF operations, Word editing, Excel processing, file system, knowledge base search'
              },
              {
                title: 'Media Editing',
                desc: 'Video editing, image processing, format conversion'
              },
              {
                title: 'Network Communication',
                desc: 'Browser automation, HTTP requests, WebSocket, email sending'
              },
              {
                title: 'System Tools',
                desc: 'PowerShell, registry, system info, environment variables, task scheduler'
              },
              {
                title: 'AI Capabilities',
                desc: 'OCR recognition, speech synthesis, speech recognition'
              }
            ]
          }
        },
        
        // Permission Management
        permission: {
          title: 'Permission Management',
          intro: {
            title: 'Fine-grained Permission Control',
            content: 'Avelia provides tool-level permission management, you can control which tools AI can use to ensure system security.\n\nPermission Levels:\n• Allow: AI can freely use the tool\n• Ask: Requires your confirmation before use\n• Deny: AI cannot use the tool\n\nRecommended Configuration:\n• File read: Allow\n• File write/delete: Ask\n• System commands: Ask\n• Network requests: Allow'
          },
          config: {
            title: 'Configure Permissions',
            steps: [
              'Click Settings → Permission Management',
              'View all available tools list',
              'Set permission level for each tool',
              'Can batch set by category',
              'Takes effect immediately after saving',
              'Can adjust permission settings anytime'
            ]
          }
        },
        
        // Troubleshooting
        troubleshooting: {
          title: 'Troubleshooting',
          common: {
            title: 'Common Issues',
            content: [
              {
                title: 'AI Cannot Call Tools',
                desc: 'Check permission settings, ensure tool permission is "Allow" or "Ask". View logs for specific error information.'
              },
              {
                title: 'Model Response Slow',
                desc: 'May be network issue or model server high load. Try switching to other models, or use local Ollama models.'
              },
              {
                title: 'Knowledge Base Search Inaccurate',
                desc: 'Re-index knowledge base, ensure document format is correct. Use more specific search keywords.'
              },
              {
                title: 'Browser Automation Failed',
                desc: 'Ensure Chrome browser is installed. Check if webpage has anti-scraping mechanisms. Try reducing operation speed.'
              },
              {
                title: 'Group Members Not Responding',
                desc: 'Check member listening configuration, ensure correct listening objects are set. Use @mention to ensure members receive messages.'
              }
            ]
          }
        },
        
        // Other Notes
        otherNotes: {
          title: 'Other Notes',
          concepts: {
            title: 'Driver vs Skill',
            content: [
              {
                title: 'Driver',
                desc: 'Low-level capability module providing basic toolsets. Covers desktop control, file operations, media processing, network communication, and more. Drivers are the basic capability units called by AI, like a "toolbox".'
              },
              {
                title: 'Skill',
                desc: 'High-level business logic encapsulation based on drivers. For example, "Douyin Comment Finder" skill calls multiple underlying drivers like browser driver and file driver to complete complex automation tasks. Skills are complete solutions for users, like "specific work done using the toolbox".'
              }
            ]
          }
        }
      },
      quickLinks: {
        manual: 'User Manual',
        guide: 'Feature Guide',
        bestPractice: 'Best Practices',
        help: 'Get Help'
      },
      sections: {
        quickStart: {
          title: 'Quick Start',
          install: { name: 'Installation Guide', desc: 'How to install and configure Avelia for the first time' },
          basicUse: { name: 'Basic Usage', desc: 'Learn about chat mode and task mode' },
          configModel: { name: 'Configure Models', desc: 'Add and manage AI models' }
        },
        tutorials: {
          title: 'Feature Tutorials',
          smartChat: { name: 'Smart Dialogue', desc: 'How to have natural conversations with Avelia' },
          taskExec: { name: 'Task Execution', desc: 'Use tools to complete complex tasks' },
          knowledge: { name: 'Knowledge Base Management', desc: 'Import documents and build knowledge base' },
          customCmd: { name: 'Custom Instructions', desc: 'Add personalized instructions for models' },
          memory: { name: 'Memory Management', desc: 'Manage long-term memory and conversation history' },
          groupChat: { name: 'Group Collaboration', desc: 'Create multi-agent groups for collaborative tasks' },
          channels: { name: 'Cross-Platform Channels', desc: 'Remote control via Telegram/Feishu/WeChat' },
          browserAuto: { name: 'Browser Automation', desc: 'Rich tools for intelligent web operations' },
          taskSystem: { name: 'Task Management', desc: 'Task scheduling, dependency management, retry on failure' }
        },
        advanced: {
          title: 'Advanced Features',
          permission: { name: 'Permission Management', desc: 'Tool permission configuration and security settings' },
          multiAgent: { name: 'Multi-Agent System', desc: 'Multiple AIs working together for efficiency' },
          mcpProtocol: { name: 'MCP Protocol', desc: 'Extend custom function drivers' },
          drivers: { name: 'Rich Drivers', desc: 'Desktop control, document processing, media editing, etc.' }
        },
        faq: {
          title: 'FAQ',
          troubleshooting: { name: 'Troubleshooting', desc: 'Solve common problems during usage' },
          otherNotes: { name: 'Other Notes', desc: 'Basic concepts: Driver, Skill, Tool, etc.' }
        }
      },
      helpSection: {
        title: 'Can\'t find what you need?',
        subtitle: 'We\'re always ready to help you solve problems',
        contactSupport: 'Contact Support',
        joinCommunity: 'Join Community'
      }
    },
    
    // Footer
    footer: {
        tagline: 'Avelia extends intelligence beyond the screen into projects, devices, and real environments, creating a system that keeps work moving forward.',
        product: {
          title: 'Product',
          features: 'Platform',
          download: 'Node Downloads',
          docs: 'Docs',
          openCenter: 'Open Center'
        },
      support: {
        title: 'Support',
        help: 'Help Center',
        community: 'Community',
        feedback: 'Feedback',
        contact: 'Contact Us'
      },
      copyright: '© 2026 China.Anhui Lingyuan Robot Technology Co., Ltd. All rights reserved.',
      status: {
        timeline: 'Platform Status',
        stable: 'Running',
        mission: 'Node Network',
        active: 'Expanding'
      }
    }
  }
}

export const t = (language, key) => {
  const keys = key.split('.')
  let value = translations[language]
  
  for (const k of keys) {
    value = value?.[k]
  }
  
  return value || key
}
